module.exports = __webpack_public_path__ + "static/media/garden.8d9baac2.JPG";